import {commitMutation, graphql} from 'react-relay'
import type {Environment} from 'relay-runtime'
import type {
  updateIssueIssueTypePickerMutation,
  updateIssueIssueTypePickerMutation$data,
} from './__generated__/updateIssueIssueTypePickerMutation.graphql'
import type {IssueType} from '../components/IssueTypePicker'

export function commitUpdateIssueIssueTypePickerMutation({
  environment,
  input: {issueId, issueType},
  onError,
  onCompleted,
}: {
  environment: Environment
  input: {issueId: string; issueType: IssueType | null}
  onError?: (error: Error) => void
  onCompleted?: (response: updateIssueIssueTypePickerMutation$data) => void
}) {
  return commitMutation<updateIssueIssueTypePickerMutation>(environment, {
    mutation: graphql`
      mutation updateIssueIssueTypePickerMutation($input: UpdateIssueIssueTypeInput!) @raw_response_type {
        updateIssueIssueType(input: $input) {
          issue {
            id
            issueType {
              ...IssueTypePickerIssueType
            }
          }
        }
      }
    `,
    variables: {
      input: {issueId, issueTypeId: issueType?.id || null},
    },
    optimisticResponse: {
      updateIssueIssueType: {
        issue: {
          id: issueId,
          issueType: issueType
            ? {
                id: issueType.id,
                isEnabled: issueType.isEnabled,
                name: issueType.name,
              }
            : null,
        },
      },
    },
    onError: error => onError && onError(error),
    onCompleted: response => onCompleted && onCompleted(response),
  })
}
